@if ((totals()?.count ?? 0) > 0) {
  <section class="employee-basket-card employee-current-benefits">
    <mat-expansion-panel
      class="employee-current-benefits__panel"
      [expanded]="expanded()"
      (expandedChange)="expanded.set($event)"
    >
      <mat-expansion-panel-header class="employee-current-benefits__panel-header">
        <mat-panel-title class="employee-current-benefits__header-block">
          <div class="employee-current-benefits__header">
            <mat-icon class="employee-basket-card__dot" [style.color]="wls.primaryColor"
              >lens</mat-icon
            >
            <span class="employee-current-benefits__title" [style.color]="wls.accentColor">
              {{ 'employee.basket.current-benefits' | translate }}
            </span>
            <span
              class="employee-current-benefits__count"
              [style.background-color]="wls.primaryColor"
              [style.color]="wls.primaryContrastingColor"
            >
              {{ totals()!.count }}
            </span>
            @if (hasSignatureRequired()) {
              <mat-icon class="employee-current-benefits__warning" [svgIcon]="'fo-warn'"></mat-icon>
            }
          </div>

          <div class="employee-basket-card__columns">
            <span class="employee-basket-card__column-label"></span>
            <span class="employee-basket-card__column-amount">
              {{ 'employee.basket.amount' | translate }}
            </span>
            @if (showNetSavingColumn()) {
              <span class="employee-basket-card__column-net-saving" [style.color]="wls.warnColor">
                {{ 'employee.basket.net-saving' | translate }}
              </span>
            }
          </div>

          <div
            class="employee-basket-card__amounts-row employee-current-benefits__total-row"
            [class.employee-current-benefits__total-row_collapsed]="!expanded()"
          >
            <span
              class="employee-basket-card__column-label employee-current-benefits__total-row-title"
            >
              {{ 'employee.basket.total-amount' | translate }}
            </span>
            <span class="employee-basket-card__column-amount">
              {{ totals()!.amount | flexyooNumber }}
            </span>
            @if (showNetSavingColumn()) {
              <span
                class="employee-basket-card__column-net-saving employee-current-benefits__total-net-saving"
                [style.color]="wls.warnColor"
              >
                {{ totals()!.netSaving | flexyooNumber }}
              </span>
            }
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @for (group of groups(); track group.status) {
        <div class="employee-current-benefits__group">
          <div class="employee-current-benefits__group-header">
            <mat-icon class="employee-basket-card__dot" [style.color]="group.color">lens</mat-icon>
            <span>{{ group.titleKey | translate }}</span>
            @if (group.showWarning) {
              <mat-icon class="employee-current-benefits__warning" [svgIcon]="'fo-warn'"></mat-icon>
            }
          </div>
          @for (benefit of group.benefits; track benefit.id) {
            <flexyoo-employee-basket-benefit-row
              [benefit]="benefit"
              [isSelected]="benefit.id === selectedBenefitId()"
              [showNetSavingColumn]="showNetSavingColumn()"
              (sign)="signBenefit.emit($event)"
            />
          }
        </div>
      }
    </mat-expansion-panel>
  </section>
}
